<template>
  <div class="flex flex-wrap col-12 white-bg border-box body-padding">
    <div class="flex col-12 h3">Sélectionnez le participant:</div>
    <div class="flex flex-wrap col-12 mt2">
      <NewTDAParticipant v-for="p in availableParticipants" :key="p.uuid" :participant="p" />
    </div>
    <NewTDAAddParticipant class="mt2" />
  </div>
</template>

<script>
import NewTDAParticipant from '@/components/participants/NewTDAParticipant.vue';
import NewTDAAddParticipant from '@/components/participants/NewTDAAddParticipant.vue';

export default {
  components: { NewTDAParticipant, NewTDAAddParticipant },
  computed: {
    availableParticipants () {
      return this.$store.state.user.contacts;
    }
  }
};
</script>
